<template>
  <v-card color="basil">
    <v-tabs
      v-model="tab"
      background-color="body"
      color="deep-purple accent-4"
      grow
      icons-and-text
    >
      <v-tab href="#issue">
        {{ $t("_issues.issues").toLocaleUpperCase(lang) }}
        <v-icon>mark_unread_chat_alt</v-icon>
      </v-tab>

      <!-- <v-tab href="#incident">
        {{ $t("_mayor.contact") }}

        <v-icon>phone</v-icon>
      </v-tab> -->
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="1" value="issue">
        <v-card>
          <issue-category-settings />
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2" value="incident">
        <v-card >
          <contact />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Contact from "./Contact.vue";
import IssueCategorySettings from "./IssueCategorySettings";
import { mapGetters } from "vuex";

export default {
  components: { IssueCategorySettings, Contact },
  data() {
    return {
      tab: null,
      valid: false,
      categoryName: "",
      categoryRules: [(v) => !!v || $t("_rules.categoryRules")],
    };
  },
  computed: {
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
  },
};
</script>


<style>
/* Helper classes */
.basil {
  background-color: #fffbe6 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>
